import styles from '../../../style.module.scss';
import {useState} from "react";
import useStore from "../../../store/store";

const TGHint = () => {
    const [open, setOpen] = useState(true)
    const lang = useStore((state) => state.lang)

    const handleClose = () => {
        setOpen(false)
    }
    return (
        <div className={styles.tgHint}>
            {
                !!open && (
                    <div className={styles.box}>
                        <button type={'button'} className={styles.close} onClick={handleClose}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4.08859 4.21569L4.14645 4.14645C4.32001 3.97288 4.58944 3.9536 4.78431 4.08859L4.85355 4.14645L10 9.293L15.1464 4.14645C15.32 3.97288 15.5894 3.9536 15.7843 4.08859L15.8536 4.14645C16.0271 4.32001 16.0464 4.58944 15.9114 4.78431L15.8536 4.85355L10.707 10L15.8536 15.1464C16.0271 15.32 16.0464 15.5894 15.9114 15.7843L15.8536 15.8536C15.68 16.0271 15.4106 16.0464 15.2157 15.9114L15.1464 15.8536L10 10.707L4.85355 15.8536C4.67999 16.0271 4.41056 16.0464 4.21569 15.9114L4.14645 15.8536C3.97288 15.68 3.9536 15.4106 4.08859 15.2157L4.14645 15.1464L9.293 10L4.14645 4.85355C3.97288 4.67999 3.9536 4.41056 4.08859 4.21569L4.14645 4.14645L4.08859 4.21569Z"
                                    f/>
                            </svg>

                        </button>
                        <div className={styles.text}>
                            {lang === 'en'
                                ? 'Filling in this field will speed up application processing'
                                : 'Заполнение поля повысит скорость обработки заявки'}
                        </div>
                    </div>
                )
            }

        </div>
    );
};

export default TGHint;